import MuiCard from '@mui/material/Card';
import MuiCardContent from '@mui/material/CardContent';
import MuiCardMedia from '@mui/material/CardMedia';
import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import IconComponent from '../Icon/Icon';

const PREFIX = 'Card';

const classes = {
  cardMui: `${PREFIX}-cardMui`,
  details: `${PREFIX}-details`,
  content: `${PREFIX}-content`,
  avatarDiv: `${PREFIX}-avatarDiv`,
  avatarImage: `${PREFIX}-avatarImage`,
  iconDiv: `${PREFIX}-iconDiv`,
  linkStyle: `${PREFIX}-linkStyle`
};

const StyledMuiCard = styled(MuiCard)(({ theme }) => ({
  [`&.${classes.cardMui}`]: {
    display: 'flex',
    backgroundColor: '#BED5DE',
    height: '132px'
  },

  [`& .${classes.details}`]: {
    position: 'relative',
    width: '100%'
  },

  [`& .${classes.content}`]: {},

  [`& .${classes.avatarDiv}`]: {
    padding: '16px'
  },

  [`& .${classes.avatarImage}`]: {
    height: '100px',
    width: '100px',
    borderRadius: '50%'
  },

  [`& .${classes.iconDiv}`]: {
    position: 'absolute',
    bottom: '10px',
    right: '10px'
  },

  [`& .${classes.linkStyle}`]: {
    textDecoration: 'none',
    color: theme.palette.text.primary
  }
}));

export interface CardItem {
  title?: string;
  titleUrl?: string;
  subtitle?: string;
  subtitleUrl?: string;
  id?: string;
  symbol?: string;
  iconBgColor?: string;
  iconElement?: JSX.Element;
  iconUrl?: string;
  image?: string;
}
export type CardProps = {
  /**  process card information */
  item: CardItem;
};

export default function Card({ item }: CardProps) {
  return (
    <StyledMuiCard raised className={classes.cardMui}>
      <div className={classes.avatarDiv} data-testid="card-avatar">
        {item.image && (
          <MuiCardMedia className={classes.avatarImage} image={item.image} title="avatar image" />
        )}
      </div>
      <div className={classes.details} data-testid="card-content">
        <MuiCardContent className={classes.content}>
          <Typography variant="subtitle1">
            {item.titleUrl && (
              <RouterLink className={classes.linkStyle} to={item.titleUrl}>
                {item.title}
              </RouterLink>
            )}
            {!item.titleUrl && item.title}
          </Typography>
          <Typography variant="body2">
            {item.subtitleUrl && <Link href={item.subtitleUrl}>{item.subtitle}</Link>}
            {!item.subtitleUrl && item.subtitle}
          </Typography>
        </MuiCardContent>
        <div className={classes.iconDiv} data-testid="card-icon">
          <IconComponent bgColor={item.iconBgColor} element={item.iconElement} url={item.iconUrl} />
        </div>
      </div>
    </StyledMuiCard>
  );
}
